import React, { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import { useHistory, useParams } from "react-router-dom";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { Step } from "src/screens/process/step/Step";
import { Person } from "src/api/Notification";
import { Route, selectRoute } from "src/config/routes";
import { useTranslation } from "react-i18next";
import styles from "./ContactPersons.module.css";

const ContactPersonsBase = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { processId } = useParams<{ processId: string; stepId: string }>();
    const { easyContactStore, uiStore } = useContext(RootStoreContext);
    const { nextStep } = easyContactStore.stepNavigation;

    const onSelectAvailableContactPerson = useCallback(
        (person: Person) => (e: React.ChangeEvent<HTMLButtonElement>) => {
            if (person.id !== easyContactStore?.backendContactInformation?.id) {
                easyContactStore.setSendingPerson({});
            }

            easyContactStore.setBackendContactInformation(person);

            if (nextStep) {
                history.push(
                    selectRoute(Route.step, { processId, stepType: String(nextStep.type), stepId: nextStep.id })
                );
            }
        },
        [easyContactStore, history, nextStep, processId]
    );

    let hasAvailableContactPersonsFromBackend = false;
    let availableContactPersonsButtons: any[] = [];

    if (
        easyContactStore.backendAvailableContactPersons &&
        easyContactStore.backendAvailableContactPersons?.length > 0
    ) {
        hasAvailableContactPersonsFromBackend = true;

        const availableContactPersonsButtonsClasses = `mb-3 mx-auto ${styles.ContactSelectionButton}`;

        availableContactPersonsButtons = easyContactStore.backendAvailableContactPersons.map(
            (person: Person, index: number) => {
                return (
                    <UI.Button
                        key={`availableContactPerson-${index}`}
                        label={`${person.name1 ?? ""} ${person.name2 ?? ""}`}
                        className={availableContactPersonsButtonsClasses}
                        onClick={onSelectAvailableContactPerson(toJS(person))}
                    />
                );
            }
        );

        availableContactPersonsButtons.push(
            <UI.Button
                key={"availableContactPerson-other"}
                label={t("screens.contact.other_person")}
                className={availableContactPersonsButtonsClasses}
                onClick={onSelectAvailableContactPerson({})}
            />
        );
    }

    return (
        <Step>
            <UI.Container className="pt-4">
                <UI.Row>
                    <UI.Col md={uiStore.defaultColumnSize.md}>
                        {hasAvailableContactPersonsFromBackend ? (
                            <div>{availableContactPersonsButtons}</div>
                        ) : undefined}
                    </UI.Col>
                </UI.Row>
            </UI.Container>
        </Step>
    );
};

export const ContactPersons = Sentry.withProfiler(observer(ContactPersonsBase));
